// API client for the admin Assessment dashboard (GET /api/assessment/admin/dashboard).
//
// Envelope: { data, isError, statusCode, errorMessage }. `data`:
//   totalStudents, totalTests, totalQuestions   - all-time (course-scoped when
//                                                 courseId is given), NOT affected by the date range
//   totalAttempts, completionRate (%), avgScorePercentage (%), totalRevenue
//                                               - for the selected date window (default: last 30 days)
//   *Growth (totalAttempts, completionRate, avgScorePercentage, totalRevenue)
//                                               - % change vs. the immediately preceding window of the
//                                                 same length; when the previous value is 0 the backend
//                                                 returns the current value itself instead of a %
//   trend[]            { periodStart (yyyy-MM-dd), attemptCount, avgScorePercentage }; bucketed by
//                      day (<= 31 day span), week (<= 180 days) or month
//   studentsByCourse[] { label, studentCount, percentage }  - all-time
//   topTests           page { content: [{ testId, testName, courseName, attemptCount,
//                      avgScorePercentage, status }], page, size, totalElements, totalPages, hasNext }
// startDate / endDate are calendar dates (yyyy-MM-dd); endDate is inclusive.
import api from "../axiosInstance";

export { apiErrorMessage } from "./assessmentHierarchy";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );

export const getAdminDashboard = ({
  courseId,
  startDate,
  endDate,
  topTestsPage = 0,
  topTestsSize = 5,
} = {}) =>
  api
    .get("/api/assessment/admin/dashboard", {
      params: cleanParams({ courseId, startDate, endDate, topTestsPage, topTestsSize }),
    })
    .then((res) => res.data?.data);
